import * as React from "react"
import { SVGProps } from "react"
export const HamburgerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="currentColor"
    {...props}
  >
    <path d="M19 8.175H2.987l6.375-6.488a.838.838 0 0 0 0-1.2.838.838 0 0 0-1.2 0L.4 8.364a.838.838 0 0 0 0 1.2l7.762 7.874c.15.15.375.263.6.263a.92.92 0 0 0 .6-.225.838.838 0 0 0 0-1.2L3.025 9.863H19c.45 0 .825-.375.825-.825 0-.488-.375-.863-.825-.863Z" fill="" />
  </svg>
)

